import { render } from "./PopinTuto.vue?vue&type=template&id=c8d85d46"
import script from "./PopinTuto.vue?vue&type=script&lang=js"
export * from "./PopinTuto.vue?vue&type=script&lang=js"

import "./PopinTuto.vue?vue&type=style&index=0&id=c8d85d46&lang=stylus"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__